import i18n from 'i18next';

import type { CircularSlice, CircularTooltip } from '@/components/charts/CircularChart';
import { formatNumberByLocale, parseLocale } from '@/utils/localeFormatters';

/** The doughnut hole, in px. */
export const SCENE_LABELS_CUTOUT = 58;

/** One slice per scene label, index-aligned across the three lists. */
export function sceneLabelSlices(
    data: number[],
    colors: string[],
    labels: string[]
): CircularSlice[] {
    return data.map((value, index) => ({
        label: labels[index] ?? '',
        value,
        color: colors[index] ?? '',
    }));
}

/** No title; the line names the label and its count. */
export const sceneLabelTooltip: CircularTooltip = {
    title: () => '',
    label: (slice) => {
        const locale = parseLocale(i18n.language);
        return ` ${slice.label}: ${formatNumberByLocale(slice.value || 0, locale, 0)}`;
    },
};
